import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import "./css/CCTextField.scss";
import moment from "moment-timezone";

export default function CCDatePicker({
    format,
    minDate,
    onChange,
    value,
    label,
    slotProps
}: {
    minDate?: moment.Moment;
    onChange?: (date: Date) => void;
    value?: moment.Moment;
    format?: any;
    label?: string;
    slotProps: any;
}) {
    format = format ? format : "MM/DD/YYYY";
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <div>
                <DatePicker
                    format={format}
                    minDate={minDate}
                    onChange={onChange ? (date: any) => {
                        date = date ? date.format("YYYY-MM-DD") : null;
                        return onChange(date);
                    }: undefined}
                    label={label}
                    value={value}
                    sx={{
                        '.MuiPickersInputBase-root': {
                            height: "40px",
                            width: "280px",
                        },
                        '.MuiOutlinedInput-root': {
                        },
                        '.MuiFormLabel-root': {
                            overflow: "visible",
                            lineHeight: "20px",
                            top: "-5px"
                        },
                        '.MuiInputLabel-shrink': {
                            transform: "translate(14px, -7px) scale(0.75)",
                            top: "0px"
                        },
                    }}
                    slotProps={slotProps}
                 />
            </div>
        </LocalizationProvider>
    );
}
